(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('ProductionUnit', ProductionUnit);

    ProductionUnit.$inject = ['$resource'];

    function ProductionUnit ($resource) {
        var resourceUrl =  'api/production-units/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
